module.exports = __webpack_public_path__ + "static/media/lucasa-large.e50cc401.jpg";